export default function UserMessage({ children }: { children: React.ReactNode }) {
	return (
		<div className='mb-4 text-white flex justify-end'>
			{children}
		</div>
	)
}
